import { ICurrency } from '@/entities/currency/types';

import { VabsAccMyBankDetailsQuery, VabsVirtualBalance } from '@/shared/api';
import { AccountBg2 } from '@/shared/assets';
import { ACC_IMAGES } from '@/shared/config/configs';
import { ICurrencyAccount } from '@/shared/lib';

export const serializeAccount = (
  item: VabsVirtualBalance,
  vId: string,
  //TODO: remove if there's currency entity in an acc
  currency?: ICurrency,
): ICurrencyAccount => {
  return {
    id: item.id,
    status: item.status,
    currencyName: currency?.name ?? item.currency?.ticker ?? '',
    currencyId: item.currency?.id || '',
    virtualId: vId,
    code: item.currency?.ticker || '',
    imgSrc:
      ACC_IMAGES[item.currency?.ticker as keyof typeof ACC_IMAGES] ??
      AccountBg2,
    symbol: currency?.symbol ?? item.currency?.ticker ?? '',
    value: item.availableAmount,
  };
};

export const serializeRequisites = (
  data: VabsAccMyBankDetailsQuery['vabsAccMyBankDetails']['bankDetails'],
): Record<string, Record<string, unknown>> => {
  return data.reduce((acc, item) => {
    acc[item.currency.id] = item.routes.reduce<Record<string, unknown>>(
      (routeAcc, route) => {
        routeAcc[route.schema] = route.details;
        return routeAcc;
      },
      {},
    );
    return acc;
  }, {});
};
